import { Injectable, inject,signal, DestroyRef, computed } from '@angular/core';
import {DatePipe} from '@angular/common';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {RevenueRestService} from "./revenue.rest.service";
import {RevenueKpis} from "../interfaces/revenueKpis.interface";

@Injectable({
  providedIn: 'root'
})
export class RevenueWidgetsService {

  private _currentMonth = signal<string>('');
  readonly currentMonth = this._currentMonth.asReadonly();

  private datePipe = inject(DatePipe);

  private readonly destroyRef = inject(DestroyRef);

  revenueRestService = inject(RevenueRestService);
  private _revenueKpis = signal<RevenueKpis>({
    total_revenue: 0,
    rx_packet_value: 0,
    rx_span_percent: 0,
    rx_packet_count: 0,
    target_rx_packets: 0,
    updated_at: "",
    month: "",
    idf: ""
  });
  readonly revenueKpis = this._revenueKpis.asReadonly();

  hasTargetRxPackets  = computed(() => {
    return this.revenueKpis().target_rx_packets > 0 ;
  });

  requestDashboardKpis(idf: any) {
    this.revenueRestService.requestRevenueKpis(idf)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response: any) => {
          const kpis = response.return_object || [];
          this.convertMonthNumberToName(kpis.month);
          kpis['idf'] = idf;
          this._revenueKpis.set(kpis);
        },
        error: (error: any) => {
          console.error('Error loading kpis:', error);
        }
      })
  }

  convertMonthNumberToName(monthNumber: string) {
    const date = new Date();
    date.setMonth(parseInt(monthNumber) - 1);
    const monthName = this.datePipe.transform(date, 'MMMM');
    this._currentMonth.set(monthName || '');
  }
}

